<template>  
    <div v-if="getId">
        <div v-if="builderMode" class="wiki-builder-preview">
            <div class="preview-label">
                <i class="fa fa-info-circle"></i> Wiki Content Preview (Click settings icon to edit)
            </div>
            <CustomEditor                   
                  :editorData="editorData" 
                  :editorTools="editorTools"
                  :viewMode="true"
                  @save="save"
                  @onReady="onReady"  
                  @onChange="onChange"
                  :key="editorKey"                                 
                  >
            </CustomEditor>
        </div>
        <div v-else class="wiki-patient-view">
            <CustomEditor                   
                  :editorData="editorData" 
                  :editorTools="editorTools"
                  :viewMode="true"
                  @save="save"
                  @onReady="onReady"  
                  @onChange="onChange"
                  :key="editorKey"                                 
                  >
            </CustomEditor>
        </div>
    </div>
</template>

<script>
    
    import BaseControlSkeleton from "../../skeletons/controls/BaseControlSkeleton";
    import CustomEditor from "@/components/Editor/Editor.vue";
    import { getLocalizedField } from '../../utils/languageHelper';

    export default {
        name: "WikiControl",
        extends: BaseControlSkeleton,  
        components: { CustomEditor },
        props: {            
            viewSubmissionMode: Boolean
        },

        data: () => ({  
            show: false,
            wikiContent: '',
            editorKey: Date.now(), // Reactive key for forcing editor updates
            initData: {                
                blocks: [
                    {
                        type: "header",
                        data: { text: "Enter your html text...", level: 2 }
                    }
                ]                
            },

            test: {                
                blocks: [
                    {
                        type: "header",
                        data: { text: "saumil testing...", level: 2 }
                    }
                ]                
            },

            editorTools: {
                header: {
                    class: "Header",
                    inlineToolbar: ["marker", "italic", "bold", "link"]
                },

                // Register the image block so inserted images RENDER here (read-only
                // preview, patient-facing form, and the Puppeteer PDF). No uploader
                // config needed — display only; authoring/upload happens in WikiConfigView.
                image: {
                    class: "Image"
                },

                embed: {
                    class: "Embed",
                    inlineToolbar: true
                },
                list: {
                    class: "List",
                    inlineToolbar: true
                },
                delimiter: { class: "Delimiter" },
                table: {
                    class: "Table",
                    inlineToolbar: true
                },
                marker: {
                    class: "Marker",
                    shortcut: "CMD+SHIFT+M"
                },
                inlineCode: {
                    class: "InlineCode",
                    shortcut: "CMD+SHIFT+C"
                },
                paragraph: {
                    class: "Paragraph",
                    inlineToolbar: true
                },
                checklist: {
                    class: "Checklist",
                    inlineToolbar: true
                },             
            },
        }),

        watch: {
            control: {
                deep: true,
                handler(val) {
                    // Force editor to re-render when control data changes
                    this.updateEditorKey();
                },
            },
            value(val) {
                //console.log(`in wiki control, value called with val: ${JSON.stringify(val)}`);
                this.setValue(val);
            },
            // Watch for language changes to switch between English/Spanish content
            language(newLang, oldLang) {
                if (newLang !== oldLang) {
                    // Force editor to re-render with new language content
                    this.updateEditorKey();
                }
            }
        },

        created() {
            //console.log(`i am in created`);
        },

        mounted() {
            // Force remove gray backgrounds after component mounts
            this.$nextTick(() => {
                this.removeGrayBackgrounds();
            });
        },

        beforeDestroy() {            
        },

        methods: {
            
            updateEditorKey() {
                // Force editor to re-render by updating the key
                this.editorKey = Date.now();
                // Remove gray backgrounds after re-render
                this.$nextTick(() => {
                    this.removeGrayBackgrounds();
                });
            },
            
            removeGrayBackgrounds() {
                if (!this.$el) return;
                
                // Target all possible Editor.js elements that might have gray backgrounds
                const selectors = [
                    '.abc',
                    '.codex-editor',
                    '.codex-editor__redactor',
                    '.ce-block',
                    '.ce-block__content',
                    '.ce-toolbar',
                    '.ce-inline-toolbar',
                    '.ce-conversion-toolbar',
                    '.ce-settings',
                    'div[contenteditable]'
                ];
                
                selectors.forEach(selector => {
                    const elements = this.$el.querySelectorAll(selector);
                    elements.forEach(element => {
                        if (element) {
                            element.style.backgroundColor = 'transparent';
                            // Also remove any background-color from computed styles
                            if (window.getComputedStyle(element).backgroundColor !== 'rgba(0, 0, 0, 0)' && 
                                window.getComputedStyle(element).backgroundColor !== 'transparent') {
                                element.style.setProperty('background-color', 'transparent', 'important');
                            }
                        }
                    });
                });
            },
            
            onReady() {
                // Always make contenteditable false in WikiControl (it's a preview/display only)
                // Editing happens in WikiConfigView (sidebar)
                // Use $el to scope the query to this component only, not all editors on the page
                if (this.$el) {
                    const elements = this.$el.querySelectorAll('[contenteditable=true]');
                    elements.forEach(element => {
                        element.setAttribute('contenteditable', false);
                    });
                }
                
                // Remove gray backgrounds after editor is ready
                this.$nextTick(() => {
                    this.removeGrayBackgrounds();
                });
            },

            onChange: (e) => {},

            escapeRegExp(string) {
                return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
            },
            
            replaceAll(str, find, replace) {
                return str.replace(new RegExp(this.escapeRegExp(find), 'g'), replace);
            },

            update(e) {},

            setValue(e) {
                if(this.control.wikiContent && this.control.wikiContent !== '') {
                    //this.$set(this, 'wikiContent', e.wikiContent);
                    //this.$set(this, 'editorData', JSON.parse(this.control.wikiContent));
                    //this.control.wikiContent = JSON.stringify(this.test);
                    //this.$set(this.control, 'wikiContent', JSON.stringify(this.test) );
                    //this.$forceUpdate();
                }
                else {
                    //this.$set(this, 'wikiContent', this.initData);                    
                    //this.$set(this, 'editorData', JSON.parse(this.initData));                    
                }
            },      
            
            save() {},
        },

        computed: {
            builderMode() {
                // Same logic as SignatureControl - determines if we're in FormBuilder
                if (this.$parent.readOnly || this.$parent.readOnly === false)
                    return false;
                else
                    return true;
            },

            getId() {
                return `wiki-control-${this.control.uniqueId}`;
            },

            editorData() {
                // Include editorKey to force recalculation when key changes
                const key = this.editorKey;

                // For non-English languages, use localized wikiContent if available, otherwise fall back to English
                let contentToUse = null;

                if (this.language !== 'en') {
                    const localizedContent = getLocalizedField(this.control, 'wikiContent', this.language);
                    contentToUse = localizedContent || this.control.wikiContent;
                } else {
                    contentToUse = this.control.wikiContent;
                }

                if(contentToUse && contentToUse !== '') {
                    try {
                        const parsed = JSON.parse(contentToUse);
                        return parsed;
                    } catch (e) {
                        console.error('WikiControl editorData - JSON parse error:', e);
                        return this.initData;
                    }
                }
                else {
                    return this.initData;
                }
            }
        }
    }
</script>

<style scoped>
.wiki-builder-preview {
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 10px;
    background-color: #fff;
    min-height: 150px;
}

.preview-label {
    font-size: 12px;
    color: #6c757d;
    margin-bottom: 8px;
    padding: 6px 10px;
    background-color: transparent;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.preview-label i {
    color: #0d6efd;
}

.debug-info {
    font-size: 11px;
    color: #28a745;
    margin-bottom: 5px;
}

/* Remove gray background from Editor.js elements */
.wiki-builder-preview >>> .abc {
    background-color: transparent !important;
}

.wiki-builder-preview >>> .codex-editor {
    min-height: 100px;
    background-color: transparent !important;
}

.wiki-builder-preview >>> .codex-editor__redactor {
    background-color: transparent !important;
}

.wiki-builder-preview >>> .ce-block {
    background-color: transparent !important;
}

.wiki-builder-preview >>> .ce-block__content {
    padding: 5px 0;
    background-color: transparent !important;
}

.wiki-builder-preview >>> .ce-toolbar {
    background-color: transparent !important;
}

.wiki-builder-preview >>> .ce-inline-toolbar {
    background-color: transparent !important;
}

.wiki-builder-preview >>> .ce-conversion-toolbar {
    background-color: transparent !important;
}

.wiki-builder-preview >>> .ce-settings {
    background-color: transparent !important;
}

.wiki-builder-preview >>> .ce-popover {
    background-color: #fff !important;
}

.wiki-builder-preview >>> div[contenteditable] {
    background-color: transparent !important;
}

/* Ensure inline formatting is preserved and visible */
.wiki-builder-preview >>> b,
.wiki-builder-preview >>> strong {
    font-weight: bold !important;
}

.wiki-builder-preview >>> i,
.wiki-builder-preview >>> em {
    font-style: italic !important;
}

.wiki-builder-preview >>> mark,
.wiki-builder-preview >>> .cdx-marker {
    background-color: #fcf392;
    padding: 3px 0;
}

.wiki-builder-preview >>> code,
.wiki-builder-preview >>> .inline-code {
    background-color: #f4f4f4;
    padding: 2px 6px;
    border-radius: 3px;
    font-family: 'Courier New', monospace;
}

.wiki-builder-preview >>> a {
    color: #0d6efd;
    text-decoration: underline;
}

/* Bullet and numbered lists styling */
.wiki-builder-preview >>> ul,
.wiki-builder-preview >>> ol {
    margin: 10px 0;
    padding-left: 25px;
}

.wiki-builder-preview >>> ul {
    list-style-type: disc;
}

.wiki-builder-preview >>> ol {
    list-style-type: decimal;
}

.wiki-builder-preview >>> li {
    margin-bottom: 5px;
    line-height: 1.5;
}

/* Patient View Mode Styles - remove gray background */
.wiki-patient-view {
    background-color: #fff !important;
}

.wiki-patient-view >>> .abc {
    background-color: transparent !important;
}

.wiki-patient-view >>> .codex-editor {
    background-color: transparent !important;
}

.wiki-patient-view >>> .codex-editor__redactor {
    background-color: transparent !important;
}

.wiki-patient-view >>> .ce-block {
    background-color: transparent !important;
}

.wiki-patient-view >>> .ce-block__content {
    padding: 5px 0;
    background-color: transparent !important;
}

.wiki-patient-view >>> .ce-toolbar {
    background-color: transparent !important;
}

.wiki-patient-view >>> .ce-inline-toolbar {
    background-color: transparent !important;
}

.wiki-patient-view >>> .ce-conversion-toolbar {
    background-color: transparent !important;
}

.wiki-patient-view >>> .ce-settings {
    background-color: transparent !important;
}

.wiki-patient-view >>> .ce-popover {
    background-color: #fff !important;
}

.wiki-patient-view >>> div[contenteditable] {
    background-color: transparent !important;
}

/* Ensure inline formatting is preserved in patient view */
.wiki-patient-view >>> b,
.wiki-patient-view >>> strong {
    font-weight: bold !important;
}

.wiki-patient-view >>> i,
.wiki-patient-view >>> em {
    font-style: italic !important;
}

.wiki-patient-view >>> mark,
.wiki-patient-view >>> .cdx-marker {
    background-color: #fcf392;
    padding: 3px 0;
}

.wiki-patient-view >>> code,
.wiki-patient-view >>> .inline-code {
    background-color: #f4f4f4;
    padding: 2px 6px;
    border-radius: 3px;
    font-family: 'Courier New', monospace;
}

.wiki-patient-view >>> a {
    color: #0d6efd;
    text-decoration: underline;
}

/* Bullet and numbered lists styling for patient view */
.wiki-patient-view >>> ul,
.wiki-patient-view >>> ol {
    margin: 10px 0;
    padding-left: 25px;
}

.wiki-patient-view >>> ul {
    list-style-type: disc;
}

.wiki-patient-view >>> ol {
    list-style-type: decimal;
}

.wiki-patient-view >>> li {
    margin-bottom: 5px;
    line-height: 1.5;
}
</style>